module.exports = __webpack_public_path__ + "img/223-turks-and-caicos.bc4bf64b.svg";